import styled from '@emotion/styled'
import { containers, MixBlendDifference, MixBlendText } from 'style';
import TeaserImageComponent from './image.component';

const TextWrapperComponent = styled.div`
    // ${MixBlendDifference};
    // ${MixBlendText({})};
    color: #111;
    font-size: 1rem;
    line-height: 1.2;
    position: relative;

    text-align: ${props => props.align || 'left'};
    right: ${props => props.right || 'auto'};
    left: ${props => props.left || 'auto'};
    // position: absolute;
    z-index: 1;
    // bottom: 17%;
    // transform: translateX(${props => props.translateX || 0}px) translateZ(0);

    // @media (min-width: ${containers.ipad + 1}px) {
    //   visibility: hidden;
    //   ${TeaserImageComponent}:hover &,
    //   ${TeaserImageComponent}.hover & {
    //       visibility: visible;
    //   }
    // }
`;
export default TextWrapperComponent;
